import React, { useContext } from'react'; 
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from '../context/AuthContext';


export default function PrivateRoute({ component: Component, ...rest }) {
    const { currentUser } = useContext(AuthContext);
    // console.log("component:",Component);
    // console.log("rest:",rest);
  return (
    <Route
      {...rest}
      render={props => {
          // console.log("props:",props);
        return currentUser ? <Component {...props} /> : <Redirect to="/login" />
      }}
    ></Route>
  )
}